export enum PaymentPeriod {
    ANNUAL = "annually",
    MONTHLY = "monthly",
}
